import { Injectable } from '@angular/core';
import { MarketingDao } from '../dao/marketing.dao';

@Injectable({
	providedIn: 'root'
})
export class MarketingService {
	constructor(private marketingDao: MarketingDao) {}

	/* istanbul ignore next */
	public registerEmailAddressForLoyalty$(email, retries) {
		return this.marketingDao.registerEmailAddressForLoyalty$(
			email,
			retries
		);
	}

	/* istanbul ignore next */
	public registerEmailAddressForLoyaltyFNS$(email, retries) {
		return this.marketingDao.registerEmailAddressForLoyaltyFNS$(
			email,
			retries
		);
	}
}
